import { RootState } from 'app/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectAnnotationsByTopicID = createSelector(
  [(state: RootState) => state.topicAnnotations, (_: RootState, topicId: number) => topicId],
  (topicAnnotations, topicId) => {
    if (topicAnnotations[topicId]) {
      return topicAnnotations[topicId].annotations ?? []
    }
    return []
  }
)

export const selectAnnotationsInfoByTopicId = createSelector(
  [(state: RootState) => state.topicAnnotations, (_: RootState, topicId?: number) => topicId],
  (topicAnnotations, topicId) => {
    if (topicId !== undefined && topicAnnotations[topicId]) {
      return {
        annotations: topicAnnotations[topicId].annotations ?? [],
        isOperating: topicAnnotations[topicId].status === 'operating',
        operatingId: topicAnnotations[topicId].operatingId
      }
    }
    return {
      annotations: [],
      isOperating: false,
      operatingId: undefined
    }
  }
)
